// Aba aberta no clique cujo endereço só sai depois de uma requisição (ORCA-1925).

export interface PendingWindow {
    navigate(url: string): void;
    close(): void;
}

/**
 * O Safari bloqueia o window.open feito quando a resposta da API chega, por já não estar no clique.
 * Por isso a aba abre em branco no clique e recebe o endereço depois. Deve ser chamada direto no
 * handler do clique. Se a aba foi bloqueada ou fechada, navigate tenta abrir uma nova.
 */
export function openPendingWindow(): PendingWindow {
    const win = window.open('', '_blank');
    if (win) {
        win.opener = null;
    }

    return {
        navigate: (url) => {
            if (win && !win.closed) {
                win.location.href = url;
            } else {
                window.open(url, '_blank');
            }
        },
        close: () => win?.close(),
    };
}
